import React, {useContext, useEffect} from 'react';
import jwtDecode from 'jwt-decode';
import useLocalStorage from "../hooks/useLocalStorage";

const AuthContext = React.createContext({
    user: {},
    setUser: () => {
    },
    isSignedIn: () => {
    },
    getId: () => {
    },
    getGrantedScopes: () => {
    },
    getHostedDomain: () => {
    },
    getBasicProfile: () => {
    },
    getName: () => {
    },
    getEmail: () => {
    },
    getGivenName: () => {
    },
    getFamilyName: () => {
    },
    getImageUrl: () => {
    },
    getIdToken: () => {
    },
});

const Auth = props => {
    const {children} = props;
    const [user, setUser] = useLocalStorage('user', null);
    const [jwt, setJwt] = useLocalStorage('jwt', null);

    useEffect(() => {
        if (user && user.tokenId) {
            try {
                setJwt(jwtDecode(user && user.tokenId))
            } catch (exception) {
                console.error('jwtDecode failed', {exception})
                setJwt(null)
                setUser(null)
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user])

    const isSignedIn = () => (jwt && jwt.exp) > (Date.now() / 1000);
    const getId = () => jwt && jwt.sub;
    const getGrantedScopes = () => user && user.tokenObj && user.tokenObj.scope;
    const getHostedDomain = () => jwt && jwt.hd;
    const getBasicProfile = () => user && user.getBasicProfile();
    const getName = () => jwt && jwt.name;
    const getEmail = () => jwt && jwt.email;
    const getGivenName = () => jwt && jwt.given_name;
    const getFamilyName = () => jwt && jwt.family_name;
    const getImageUrl = () => jwt && jwt.picture;
    const getIdToken = () => user && user.tokenId;

    /**
     * TODO: Persist the user somewhere and rehydrate between sessions with
     * token revalidation
     */
    return (
        <AuthContext.Provider value={{
            user,
            setUser,
            isSignedIn,
            getId,
            getGrantedScopes,
            getHostedDomain,
            getBasicProfile,
            getName,
            getEmail,
            getGivenName,
            getFamilyName,
            getImageUrl,
            getIdToken,
        }}>
            {children}
        </AuthContext.Provider>
    )
};

const useAuth = () => {
    const context = useContext(AuthContext);
    if (context === undefined) {
        throw new Error('useAuth requires a provider in the upper scope');
    }
    return context;
};

export {Auth, useAuth}
